export enum FeaturePageLocalStorageKeyEnum {
  SEARCH_PAGE = 'search-page',
}
